import { Plane } from "@babylonjs/core/Maths/math.plane";
import { Ray } from "@babylonjs/core/Culling/ray";
import { AbstractInteractorTool } from './tools';
import { EditWallOpening } from './../cmd/EditWallOpening';
import { Util } from "../utils/Util";
import { WallOpening } from "../mdl/WallOpening";
import { WallOpeningInteractors } from "./WallOpeningInteractors";
import { CoordinatesType } from "@egr/wcf/modules/core/view/View";
import { VECTOR3_Y, intersectRayPlane, signedAngleBetweenVectors2 } from "@egr/wcf/modules/core/utils/MathUtils";
export class OpenWallOpening extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mDistanceFeedback = null;
    }
    initialize(pOpening, pHingePos, pHandlePos) {
        this.mOpening = pOpening;
        this.mOpeningDirection = (this.mOpening.endPoint.subtract(this.mOpening.startPoint)).normalize();
        this.mCommand = new EditWallOpening(this.mRoomManager, this.mOpening);
        this.mHingePos = pHingePos.clone();
        this.mHingePos.y = pHandlePos.y;
        if (this.mOpening.wall == null) {
            this.stop();
            return;
        }
        this.mHandlePos = pHandlePos.clone();
        this.mOpenPickPlane = Plane.FromPositionAndNormal(this.mHandlePos, VECTOR3_Y);
        this.mOpening.beginInteracting();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        if (this.mOpening !== null)
            this.mOpening.updateGeometry();
        this.mOpening.endInteracting();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mStartPos = pPos;
    }
    getPlanePickPos2d(pPos) {
        let tView = this.mView;
        if (tView == null)
            tView = this.mRoomManager.hoverView;
        if (tView == null)
            return (null);
        let tWO = null;
        let tSel = this.mRoomManager.app.model.selection;
        if ((tSel.length == 1) && (tSel[0] instanceof WallOpening)) {
            tWO = tSel[0];
        }
        let tPos = null;
        if (tWO != null) {
            if (tWO.type == "Door" || tWO.type == "GlassDoor" || tWO.type == "GlassInlayDoor") {
                tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                tPos = intersectRayPlane(gTmpRay, this.mOpenPickPlane);
            }
        }
        else {
            tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
            tPos = intersectRayPlane(gTmpRay, this.mOpenPickPlane);
        }
        return (tPos);
    }
    updatePointerPosition(pPos) {
        if (this.mOpening.wall == null)
            return;
        let tWD = this.mOpening.wall.wallDirection;
        if (this.mOpening.mirrorVertical) {
            tWD = tWD.negate();
        }
        let ttmp = this.mHingePos.add(Util.to3d(tWD.scale(this.mOpening.width)));
        let tV1 = Util.to2d(ttmp.subtract(this.mHingePos));
        let tV2 = Util.to2d(pPos.subtract(this.mHingePos));
        let t_angle = 0;
        if (this.mOpening.mirrorVertical) {
            t_angle = signedAngleBetweenVectors2(tV2, tV1);
            if (this.mOpening.mirrorHorizontal)
                t_angle = -t_angle;
        }
        else {
            t_angle = signedAngleBetweenVectors2(tV1, tV2);
            if (this.mOpening.mirrorHorizontal)
                t_angle = -t_angle;
        }
        if (t_angle > Math.PI / 2) {
            t_angle = -Math.PI;
        }
        if (t_angle > 0 && t_angle <= Math.PI / 2) {
            t_angle = 0;
        }
        let tdegree = (-t_angle * (180 / Math.PI));
        this.mOpening.setOpeningAngle(tdegree, true);
        if (this.mView != null) {
            this.mView.viewer.requestRenderFrame();
        }
    }
    finish() {
        if (this.mCommand == null)
            return;
        this.mApp.commands.executeCommand(this.mCommand).then(() => {
            this.mCommand = null;
            this.mOpening.updateGeometry();
            this.stop();
        });
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mDistanceFeedback = new WallOpeningInteractors(this.mRoomManager, this.mOpening);
        this.mDistanceFeedback._updateDistInteractors();
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mDistanceFeedback != null) {
            this.mDistanceFeedback.clear();
            this.mDistanceFeedback = null;
        }
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mDistanceFeedback != null) {
            this.mDistanceFeedback._updateDistInteractors();
            this.mDistanceFeedback._showOpeningWidthInteractors();
        }
    }
}
//add nested types
export var OpenOpening;
(function (OpenOpening) {
    let Mode;
    (function (Mode) {
        Mode[Mode["Move"] = 0] = "Move";
        Mode[Mode["ScaleEnd"] = 1] = "ScaleEnd";
        Mode[Mode["ScaleStart"] = 2] = "ScaleStart";
    })(Mode = OpenOpening.Mode || (OpenOpening.Mode = {}));
})(OpenOpening || (OpenOpening = {}));
let gTmpRay = Ray.Zero();
